export default __webpack_public_path__ + "static/media/YGAP.70c9cdeb.png";